import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({ selector: 'textarea[chatAutoResize]' })
export class ChatAutoResizeDirective implements OnInit {
  @Input() minRows = 1;
  @Input() maxRows = 5;

  constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  ngOnInit(): void { this.resize(); }

  @HostListener('input')
  onInput(): void { this.resize(); }

  reset(): void {
    this.el.nativeElement.style.height = 'auto';
    this.resize();
  }

  private resize(): void {
    const ta = this.el.nativeElement;
    const lineH = parseInt(getComputedStyle(ta).lineHeight, 10) || 21;
    ta.style.height = 'auto';
    const minH = this.minRows * lineH + 18; // +padding
    const maxH = this.maxRows * lineH + 18;
    ta.style.height = `${Math.min(maxH, Math.max(minH, ta.scrollHeight))}px`;
  }
}
